<template>
	<v-card class="resource-page pa-7" style="border-radius: 10px; max-width: 600px;" flat>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-alert v-model="successMessage" type="success" dismissible>
				Settings saved successfully.
			</v-alert>
			<v-alert v-model="errorMessage" type="error" dismissible> An error occurred. </v-alert>
	
			<v-card-text>
				<div class="resources-page__title-wrapper">
					<ButtonBack :button="{label: 'Resources'}" /> 
					<div class="d-flex justify-start">
						<v-btn 
							v-if="isAdvancedResources"
							class="resources-page__list-btn mr-3" 
							:ripple="false"
							icon 
						>
							<v-icon large @click="toggleList">
								{{ listView ? 'mdi-grid' : 'mdi-format-list-bulleted' }}
							</v-icon>
						</v-btn>
						<div class="d-flex align-center resources-page__search-wrapper" style="width: 100%">
							<input
								class="resources-page__search"
								type="text"
								placeholder="Search"
								v-model="filters.search"
								@input="filterSearch"
							/>
							<img :src="searchIcon" alt="Search" class="resources-page__search-icon"/>
						</div>
					</div>
				</div>
	
				<h3 
					v-if="folderTitle" 
					class="resources-page__page-title mt-4"
					:style="{marginBottom: isAdvancedResources ? '12px' : '0'}"
				>
					{{ folderTitle }}
				</h3>
	
				<!-- <ResourcesFilters 
					v-if="isAdvancedResources"
					:tags="tags"
					:currentTag="currentTag"
					@toggleTag="toggleTag"
				/> -->
	
				<v-skeleton-loader
					style="max-width: 600px;"
					v-bind="attrs"
					type="card"
					v-if="this.isLoading"
				>
				</v-skeleton-loader>
	
				<AdvancedResourceList
					v-if='!this.isLoading && this.resourcesItems.length > 0 && (isAdvancedResources && !listView)'
					:resourcesItems="resourcesItems"
				/>
	
				<ResourceList
					v-if='!this.isLoading && this.resourcesItems.length > 0 && (!isAdvancedResources || listView)'
					:resourcesItems="resourcesItems"
				/>
	
				<div v-if="!this.isLoading && this.resourcesItems.length === 0" class="mt-5 align-center">
					<NewsFeedEmpty
						title="Resources is empty at the moment."
						description="Check back later."
					/>
				</div>
	
				<div
					class="d-flex my-9 ma-auto justify-center home-page__pagination"
					v-if="!this.isLoading && this.resourcesItems.length > 0"
				>
					<Pagination 
						:page="filters.page"
						:pageCount="pageCount"
						@pageChange="onPageChange"
					/>
				</div>
	
			</v-card-text>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import arrowIcon from '@/assets/images/resourcesIcon/arrow-icon.svg'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import ResourceList from '@/components/Resource/ResourceList.vue'
import AdvancedResourceList from '../components/Resource/AdvancedResourceList.vue'
import Block from '@/mixins/Block.js'
import PageBlocked from '@/components/PageBlocked'
import Pagination from '@/components/Pagination.vue'
import ButtonBack from '@/components/ButtonBack.vue'

export default {
	name: 'ResourcePage',
	mixins: [Block],
	components: {
		ResourceList,
		NewsFeedEmpty,
		AdvancedResourceList,
		PageBlocked,
		Pagination,
		ButtonBack
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'isLoading', 'singleMeta', 'breadCrumbs', 'listView']),
		isVerticalTabs() {
			return this.$vuetify.breakpoint.mdAndUp
		},
		normalizedBreadCrumbs() {
			return this.breadCrumbs || []
		},
		resourcesItems() {
			return this.resourcesList || [];
		},
		pageCount() {
			if (!this.singleMeta) {
				return 0
			}

			return +this.singleMeta.pageCount
		},
		isAdvancedResources() {
			return !!this.$route.query.advance
		},
		folderTitle() {
			return this.$route.query.title || null
		}
	},
	watch: {
		'$route': 'fetchData',
		'filters.page': {
			handler(newValue, oldValue) {
				if (newValue !== oldValue) {
					const params = {
						search: this.filters.search,
						page: newValue,
						parentId: +this.$route.params.id
					}
					const queryString = this.formatFilters(params)
					this.getResourcesById(queryString)
				}
			},
			'singleMeta.pageCount': {
				handler(newValue) {
					if (this.filters.page > newValue) {
						this.filters.page = 1
					}
				}
			}
		},
		'singleMeta.pageCount': {
			handler(newValue) {
				if (this.filters.page > newValue) {
					this.filters.page = 1
				}
			}
		}
	},
	methods: {
		...mapActions('resources', ['getResourcesById', 'breadCrumbHandler', 'clearResources', 'toggleListView', 'getCategories']),

		isLastElement(index) {
			return index === this.normalizedBreadCrumbs.length - 1;
		},
		fetchData() {
			const params = {
				page: 1,
				parentId: +this.$route.params.id
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)

			this.getResourcesById(queryString)
		},
		onTabSwitch() {
			this.successMessage = false
			this.errorMessage = false
		},
		onPageChange(page) {
			const params = {
				search: this.filters.search,
				page: page,
			}
			const queryString = this.formatFilters(params)
			this.getCategories(queryString)
		},
		formatFilters(filters) {
			const { search, page, parentId } = filters

			let queryString = `parentId=${parentId}&page=${page}`

			if (search !== undefined && search.length > 0) {
				queryString += `&search=${search}`
			}

			return queryString
		},
		filterSearch(e) {
			clearTimeout(this.timer)

			const params = {
				search: e.target.value,
				page: 1,
				parentId: +this.$route.params.id
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)

			this.timer = setTimeout(() => {
				this.getResourcesById(queryString)
			}, 500)
		},
		toggleTag(e) {
			this.currentTag = e
		},
		toggleList() {
			this.toggleListView()
		}
	},
	data() {
		return {
			isHovered: false,
			filters: {
				page: 1,
				search: '',
			},
			searchIcon,
			arrowIcon,
			successMessage: false,
			errorMessage: false,
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			currentTag: 'All',
			tags: [
				'All',
				'Admin',
				'My Groups',
				'Tags'
			],
			pageBlockedName: 'resources'
		}
	},
	mounted() {
		const params = {
			page: 1,
			parentId: +this.$route.params.id
		}
		const queryString = this.formatFilters(params)
		if (!this.isBlocked || this.isBlocked === null) {
			if (this.singleMeta) {
				this.filters.page = +this.singleMeta.currentPage
				if (this.singleMeta.currentPage === '1') {
					this.getResourcesById(queryString)
				}
			} else {
				this.getResourcesById(queryString)
			}
		}
	},
	beforeDestroy() {
		this.clearResources()
	},
	isAdvancedResources() {
		return !!this.$route.query.advance
	}
}
</script>

<style lang="scss">
.resource-page {
	max-width: 600px;
	width: 100%;
	border-radius: 10px !important;
	margin-bottom: 30px;

	@media (max-width: 480px) {
		margin-bottom: 12px;
	}

	&__page-title {
		margin-top: 30px;
		font-size: 24px;
		font-weight: 700;
		font-family: Montserrat, sans-serif;
		color: #4A4A4A;
		line-height: 29px;
	}

	&__title {
		font-style: normal;
		cursor: pointer;
		font-weight: bold;
		font-size: 40px;
		line-height: 35px;
		color: #202232;
	}
}

.navigate-back {
	&__icon {
		color: var(--accent-color);
	}

	&__text {
		color: var(--accent-color);
		font-size: 15px;
		font-weight: 700;
		line-height: 18px;
		text-decoration: underline;
	}

}

.cursor-pointer {
	cursor: pointer;
}

@media screen and (max-width: 960px) {
	.resource-page__title {
		font-size: 25px !important;
	}
}
</style>
